// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"3d1fda9a","453":"1227c6b1"}[chunkId] + ".chunk.js";
};